/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { Profiler, useContext, useEffect, useRef } from "react";
import { Title, useTheme } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import PopularFlights from "../components/elements/PopularFlights";
import FrequentlyAskedQuestions from "../components/elements/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import UspBlock from "../components/elements/UspBlock";
import { trackMetaLandingsCustomGoalsV2 } from "../utils/experiments/track-meta-landings-v2";
import { SearchDesktop, SearchOutboundDesktop } from "../app/routes";
import { AppShellDesktop } from "../components/elements/AppShell";
import Container from "../components/elements/Container";
import useClientMetrics from "../hooks/useClientMetrics";
import useTrackPageLoad from "../hooks/useTrackPageLoad";
import { PageHeader } from "./Home";
import StaticContext from "../app/StaticContext/StaticContext";
import HomeRecentSearch from "../components/elements/HomeRecentSearch";
import Frame from "../components/elements/Frame";
import { HomeSearchHeaderDesktop } from "../components/elements/HomeSearchHeader";
import {
  RemoteAppleCardIndex,
  RemoteGeniusLaunchSheet,
  RemoteGeniusLoyalty,
  RemoteRewardsLandSheet
} from "../components/remote";
import NoSSR from "../app/NoSSR";
import useLandingPageEvents from "../hooks/c360/useLandingPageEvents";
import { GeniusFlightsHomeBanner } from "../components/elements/FlightCampaignTCBanner/GeniusHomeBanner";
import { goal, stage, trackWithDefaultStage } from "@flights/et-universal";
import { FlightsInterlinkingDesktop } from "../components/elements/FlightsInterlinking";
import useIsInViewport from "../hooks/useIsInViewport";
import EsimBanner from "../ancillaries/components/Esim/EsimBanner";
import { useSelector } from "react-redux";
import { getEsimEligibilityIndex, getFetchStatusIndex } from "../ancillaries/store/esim/selectors";
import flights_ace_web_esim_banner, {
  useTrackEsimBannerStages
} from "../utils/experiments/ace/flights_ace_web_esim_banner";
import { useEsimIndex } from "../ancillaries/hooks/Esim/useEsimFetch";
import Wrapper from "../components/atoms/Wrapper";
import { getUserInfo } from "../store/user/selectors";
import FlyAnywhereCountriesCarousel from "../components/elements/FlyAnywhere/FlyAnywhereCountriesCarousel";
import HomepageOffers from "../components/elements/HomepageOffers";
import { useSplitBoundsCondition } from "../utils/experiments/funnel/flights_split_bounds_us";
import useFlightsWebSouthwest from "../utils/experiments/funnel/flights_web_southwest";
import FlyAnywhereMapBanner from "../components/elements/FlyAnywhere/FlyAnywhereMap/FlyAnywhereMapBanner";
import useProfiler from "../hooks/useProfiler";
import { ServerInitialStateFunction } from "../app/routes";

const HomeDesktop = ({ getInitialState }: { getInitialState?: ServerInitialStateFunction }) => {
  const staticContext = useContext(StaticContext);
  const theme = useTheme();
  const i18n = useI18n();
  const trackContextEventV2 = useTrackPageLoad("index");
  const { trackRenderTime } = useClientMetrics();
  const trackLandingPageEvents = useLandingPageEvents();
  const { isSplitBounds } = useSplitBoundsCondition();

  const isEsimEligible = !!useSelector(getEsimEligibilityIndex);
  const showEsimBanner = isEsimEligible && !!flights_ace_web_esim_banner.trackWithDefaultStage();
  const fetchEsim = useEsimIndex();
  const esimFetchStatus = useSelector(getFetchStatusIndex);
  const esimBannerRef = useRef<HTMLDivElement>(null);
  const eSimInViewport = useIsInViewport(esimBannerRef.current);
  /** end - flights_ace_web_esim_banner */
  useTrackEsimBannerStages(isEsimEligible);
  const userInfo = useSelector(getUserInfo);
  const { isLoggedIn } = useProfiler();
  const loggedIn = isLoggedIn();

  const flightsWebSouthwest = useFlightsWebSouthwest();

  // This is the server side initial state from server/screens
  if (getInitialState && staticContext.set) {
    staticContext.set({ getInitialState: getInitialState() });
  }

  /** start - flights_ace_web_esim_banner */
  useEffect(() => {
    if (esimFetchStatus === "initial") {
      void fetchEsim();
    }
  }, [esimFetchStatus, fetchEsim]);

  useEffect(() => {
    if (showEsimBanner && userInfo) {
      flights_ace_web_esim_banner.stages.with_booking();
    }
  }, [showEsimBanner, userInfo]);

  useEffect(() => {
    if (eSimInViewport && userInfo) {
      flights_ace_web_esim_banner.goals.viewed_esim_banner();
    }
  }, [eSimInViewport, userInfo]);
  /** end - flights_ace_web_esim_banner */

  useEffect(() => {
    SearchDesktop.preload();
    flightsWebSouthwest.trackStages();
    /* start - flights_split_bounds_us */
    if (isSplitBounds) {
      SearchOutboundDesktop.preload();
    }
    /* end - flights_split_bounds_us */
    trackContextEventV2();
    goal("flights_home_page_view");
    goal("tbu_vertical_home_page_view");
    trackLandingPageEvents("page_view", "homepage");
    stage("flights_web_cat_home_page_traffic_www_aa", 4);

    // track meta users going to index page
    trackMetaLandingsCustomGoalsV2(2, "desktop");

    stage("flights_web_cat_fly_anywhere_map_view_www", 1);
    if (loggedIn) {
      stage("flights_web_cat_fly_anywhere_map_view_www", 4);
    } else {
      stage("flights_web_cat_fly_anywhere_map_view_www", 5);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Profiler id="screen" onRender={trackRenderTime}>
      <PageHeader />
      <AppShellDesktop>
        <Frame
          alignItems="center"
          direction="column"
          justifyContent="center"
          grow={1}
          attributes={{ style: { width: "100%" } }}
        >
          <HomeSearchHeaderDesktop />

          <NoSSR>
            <HomeRecentSearch />
          </NoSSR>

          <HomepageOffers isMobile={false} />

          {!!trackWithDefaultStage("flights_web_cat_fly_anywhere_map_view_www", 1) && (
            <Container style={{ margin: `${theme.units.spacing_8x} auto 0`, alignItems: "start" }}>
              <FlyAnywhereMapBanner />
            </Container>
          )}

          <Container style={{ margin: `${theme.units.spacing_8x} auto 0`, alignItems: "start" }}>
            <FlyAnywhereCountriesCarousel />
          </Container>

          <GeniusFlightsHomeBanner />

          <PopularFlights isMobile={false} />

          <RemoteAppleCardIndex />

          <RemoteGeniusLoyalty />

          {showEsimBanner && (
            <Container style={{ margin: `${theme.units.spacing_8x} auto`, alignItems: "start" }}>
              <Title title={i18n.trans(t("flights_genius_section_header"))} variant="headline_2" titleTagName="h2" />
              <Wrapper elementRef={esimBannerRef} noBorder noPadding>
                <EsimBanner context="index" />
              </Wrapper>
            </Container>
          )}

          <Frame attributes={{ style: { width: "100%" } }} mt={8} mb={8}>
            <UspBlock />
          </Frame>

          <FlightsInterlinkingDesktop />

          <Container pb={8}>
            <FrequentlyAskedQuestions />
          </Container>
        </Frame>
      </AppShellDesktop>
      {<RemoteGeniusLaunchSheet />}
      <RemoteRewardsLandSheet />
    </Profiler>
  );
};

export default HomeDesktop;
